export default "/react/avitoIcon-9eb635fa.svg";